import axios from "axios";

export const notificationsData = () => {
  return axios
    .get("/notification.json")
    .then((response) => {
    //   console.log(response.data);
      return response;
    });
};